export const messageNotifications = [
  // 'https://graph.microsoft.com/Mail.Read',
  'https://www.googleapis.com/auth/gmail.readonly',
];
